import { FC, HTMLAttributes, ReactNode } from 'react';

import Search from '@/assets/icons/Search';

import { SearchType } from '../../../types';
import SearchTypeLabel from '../SearchTypeLabel/SearchTypeLabel';

import iconStyles from '../../styles/searchIcons.module.css';
import styles from './SearchInputAutocompletePreview.module.css';

const SearchInputAutocompletePreview: FC<
  HTMLAttributes<HTMLDivElement> & { children: ReactNode | string; isSelected: boolean; searchType: SearchType }
> = ({ isSelected, children, searchType = 'empty', ...divProps }) => {
  return (
    <div
      data-testid='searchInputPreview'
      data-isselected={isSelected}
      className={styles.autocompletePreview}
      style={{
        ...(isSelected
          ? {
              backgroundColor: 'var(--tractie-color-background-selected-default)',
              color: 'var(--tractie-color-content-selected)',
              fill: 'var(--tractie-color-content-emphasis)',
            }
          : {}),
      }}
      {...divProps}
    >
      <Search className={iconStyles.searchIcon} data-testid='search-input-preview-icon' />
      <SearchTypeLabel searchType={searchType} />
      {children}
    </div>
  );
};
export default SearchInputAutocompletePreview;
